const enabledDoctors = ({doctor}) => doctor.items;
const enabledDoctorsErrors = ({doctor}) => doctor.errors;

export const selectors = {
    enabledDoctors,
    enabledDoctorsErrors
};
